import { render, staticRenderFns } from "./TypeRadio.vue?vue&type=template&id=0adee421&scoped=true"
import script from "./TypeRadio.vue?vue&type=script&lang=js"
export * from "./TypeRadio.vue?vue&type=script&lang=js"
import style0 from "./TypeRadio.vue?vue&type=style&index=0&id=0adee421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adee421",
  null
  
)

export default component.exports